import { create } from 'zustand';
import { type ListarComprasAgilesUi } from '../schemas/compras-agiles/listar-compras-agiles/ui.schema';
import { ComprasAgilesService } from '../services/compras-agiles.service';
import { useLoadingStore } from './loadingStore';
import { useAlertStore } from './alertStore';

interface FetchOptions {
  silent?: boolean;
}

interface ComprasAgilesState {
  comprasAgiles: ListarComprasAgilesUi[];
  page: number;
  limit: number;
  total: number;
  setComprasAgiles: (comprasAgiles: ListarComprasAgilesUi[]) => void;
  setPagination: (page: number, limit: number, total: number) => void;
  fetchComprasAgiles: (options?: FetchOptions & { page?: number; limit?: number; estado?: string }) => Promise<void>;
}

export const useComprasAgilesStore = create<ComprasAgilesState>((set, get) => ({
  comprasAgiles: [],
  page: 1,
  limit: 20,
  total: 0,
  setComprasAgiles: (comprasAgiles) => set({ comprasAgiles }),
  setPagination: (page, limit, total) => set({ page, limit, total }),
  fetchComprasAgiles: async (options: FetchOptions & { page?: number; limit?: number; estado?: string } = {}) => {
    const { silent = false, page, limit, estado } = options;
    const currentState = get();
    const pageToUse = page ?? currentState.page;
    const limitToUse = limit ?? currentState.limit;
    
    const setLoading = useLoadingStore.getState().setLoading;
    const showAlert = useAlertStore.getState().showAlert;

    if (!silent) {
      setLoading(true);
    }

    try {
      const result = await ComprasAgilesService.listarComprasAgiles(pageToUse, limitToUse, estado);
      set({ 
        comprasAgiles: result.data,
        page: result.page,
        limit: result.limit,
        total: result.total
      });
      
      if (!silent) {
        showAlert('Compras ágiles cargadas exitosamente', 'success');
      }
    } catch (error) {
      console.error('Error:', error);
      const errorMessage = error instanceof Error ? error.message : 'Error desconocido';
      showAlert(errorMessage, 'error');
    } finally {
      if (!silent) {
        setLoading(false);
      }
    }
  }
})); 